import React, { ReactNode } from "react";

type TContainerIsShow = {
  children: ReactNode;
  isShow: boolean;
};

export const ContainerIsShow: React.FC<TContainerIsShow> = ({
  children,
  isShow,
}) => (isShow ? <>{children}</> : <></>);
